import http from 'hub-http/clients/apiClient';
import { transformEnrichPayload } from '../../utils';
export async function enrichRecords(context) {
  const {
    enrichmentType,
    selectionIds,
    shouldOverwrite
  } = context;
  const idsKey = `${enrichmentType}Ids`;
  const payload = transformEnrichPayload(selectionIds);
  const enrichAssociatedRecords = context.enrichAssociations;
  return await http.post(`enrichment-platform/v2/${enrichmentType}/updates/apply/batch`, {
    data: {
      [idsKey]: payload,
      shouldOverwrite,
      enrichAssociatedRecords
    }
  });
}